<template>
  <div class="space-y-6 bg-white py-6 px-4 sm:p-6">
    <div>
      <h3 class="text-lg font-medium leading-6 text-gray-900">Email template</h3>
      <p class="mt-1 text-sm text-gray-500">You can update the email options below, or change its content on the right.</p>
    </div>

    <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-4">
      <div class="sm:col-span-4">
        <label for="first-name" class="block text-sm font-medium text-gray-700">
          Email Subject
        </label>
        <div class="mt-1">
          <input
            v-model="$v.template_subject.$model"

            type="text"
            name="first-name"
            id="first-name"
            autocomplete="given-name"
            class="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
          >
        </div>
      </div>

      <div class="sm:col-span-4">
        <label for="country" class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
          Template Type
        </label>
        <div class="mt-1">
          <select
            v-model="$v.orig_template_code.$model"

            id="country"
            name="country"
            autocomplete="country-name"
            class="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
          >
            <option value="design_email_header_template">Design Email Header</option>
            <option value="sales_email_invoice_template">Sales Email Invoice</option>
            <option value="sales_email_shipment_template">Sales Email Shipment</option>
          </select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

// import setupForm from "../../../../mixins/setupForm"
import setupForm from "@/mixins/setupForm"
import {required} from "vuelidate/lib/validators";

const fields = ["orig_template_code", "template_subject"]

export default setupForm(fields, {
  validations: {
    ...fields.reduce((obj, key) => ({
      ...obj,
      [key]: {  },
    }), {}),
  },
  created() {
    if (!this.$v.orig_template_code.$model) {
      this.$v.orig_template_code.$model  = "design_email_header_template"
    }
  },
})

</script>
